<template>
    <div class="teachers">
        <teacher-item v-for="teacher in teacherArray"
        :teacher="teacher" :key="teacher.id">
        </teacher-item>
    </div>
</template>

<script>
import TeacherItem from "./TeacherItem.vue";

export default {
  name: `Teachers`,
  props: {
    teachers: String
  },
  components: {
    TeacherItem
  },
  computed: {
    teacherArray() {
      if (this.teachers && this.teachers.length > 0) {
        const myTeachers = this.teachers.split(`,`);
        const output = [];
        if (this.$store.state.initialData.teachers.length > 0) {
          myTeachers.forEach((t) => {
            const teacher = this.$store.state.initialData.teachers.filter((item) => {
              if (parseInt(item.id, 10) === parseInt(t, 10)) {
                return true;
              }
              return false;
            });
            if (typeof teacher[0] !== `undefined`) {
              output.push(teacher[0]);
            }
          });
        }

        return output;
      }
      return [];
    }
  }
};
</script>

<style lang="scss">
.teachers {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}
</style>
